import LocationData from "../../models/LocationData";
import Services from '../../service/ApiServices'
import _ from 'lodash'

export const SET_CURRENT_LOCATION = "SET_CURRENT_LOCATION";
export const SET_CURRENT_NODE = "SET_CURRENT_NODE";
export const GET_LOCATION_TREEDATA = "GET_LOCATION_TREEDATA";
export const ADD_TREE_NODE = "ADD_TREE_NODE";
export const EDIT_TREE_NODE = "EDIT_TREE_NODE";
export const DELETE_TREE_NODE = "DELETE_TREE_NODE";
export const DUPLICATE_TREE_NODE = "DUPLICATE_TREE_NODE";
export const SET_SELECTED_LOCATIONS = "SETUP/SET_SELECTED_LOCATIONS"

export const SetSelectedLocations = (selectedLocations)=>{
    return {type: SET_SELECTED_LOCATIONS, selectedLocations}
}


export const  AddTreeNode = async (node, data)=>{
    let result = {}
    switch(data.type.code){
        case "BUILDING":
            result =  await Services.Setup.saveBuilding(data.model);                     
            node.key= result.data.key;   
            node.id= result.data.id;
            break;
        case "BED":
            result = await Services.Setup.saveBed(data.model);
            node.key= result.data.key;   
            node.id = result.data.id;
            break;
        default:
            result =  await Services.Setup.saveIntermediate(data.model, data.type.code);
            node.key= result.data.key;   
            node.id = result.data.id;
            break;
    }    
    return {type:ADD_TREE_NODE, treeNode: node }
}

export const EditTreeNode = async(node, data)=>{
    let response = null;
    switch(data.type.code){        
        case "BUILDING":
            response =  await Services.Setup.updateBuilding(data.model);
            node.key= response.data.key;  
            node.id= response.data.id; 
            break;
        case "BED":
            response = await Services.Setup.updateBed(data.model);
            node.key = response.data.key;
            node.id = response.data.id;
            break;
        default:            
            response =  await Services.Setup.updateIntermediate(data.model, data.type.code);           
            break;
    }    
    return {type:EDIT_TREE_NODE, treeNode: node }  

}

export const DeleteTreeNode = async(node)=>{   
    switch(node.type){        
        case "BUILDING":
            await Services.Setup.deleteBuildingById(node.id);
            break;
            case "BED":
                await Services.Setup.deleteBedById(node.id);
                break;
            case "FLOOR":
            case "UNIT": 
            case "WING":
            case "ROOM":               
                await Services.Setup.deleteIntermediateById(node.type,node.id);             
                break; 
            default:               
                break;
    } 
    return {type:DELETE_TREE_NODE, treeNode:node}
}
export const DuplicateTreeNode = async(node, data)=>{   
    switch(node.type){        
        case "BUILDING":
            await Services.Setup.duplicateBuilding(data);
            break;
            case "BED":
                await Services.Setup.duplicateBed(data);
                break;
            case "FLOOR":
            case "UNIT": 
            case "WING":
            case "ROOM":               
                await Services.Setup.duplicateIntermediate(data);             
                break; 
            default:               
                break;
    } 
    return {type: DUPLICATE_TREE_NODE}
}

